<div class="row">
  <div class="d-flex mb-3 justify-content-end">
    <app-refresh-button
      [state]="fetchingGlobalStatsState"
      [date]="cachedAt"
      (buttonClick)="fetchGlobalStatistics(true)"
    ></app-refresh-button>
  </div>
  <ng-container>
    <app-welcome-card
      [result]="ads"
      [loading$]="loadingGlobalStatics$ | async"
      [firstName]="(profile$ | async)?.firstName"
      [lastName]="(profile$ | async)?.lastName"
    ></app-welcome-card>
    <div class="row">
      <div
        class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 box-col-3 p-r-0"
      >
        <app-card
          [title]="impressionCard.title"
          [icon]="impressionCard.icon"
          [value]="impressionCard.value"
          [class]="'eye'"
          [isLoading]="loadingGlobalStatics$ | async"
        >
        </app-card>
      </div>
      <div
        class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 box-col-3 p-r-0"
      >
        <app-card
          [title]="uniqueConsumersCard.title"
          [icon]="uniqueConsumersCard.icon"
          [value]="uniqueConsumersCard.value"
          [class]="'eye'"
          [changes]="uniqueConsumersCard.changes"
          [growth]="uniqueConsumersCard.growth"
          [hasYesterdayGrowth]="uniqueConsumersCard.hasYesterdayGrowth"
          [isLoading]="loadingGlobalStatics$ | async"
          [infoTooltip]="'infoTooltip.uniqueConsumers' | translate"
        >
        </app-card>
      </div>
      <div
        class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 box-col-3 p-r-0"
      >
        <app-card
          [title]="reachCard.title"
          [icon]="reachCard.icon"
          [value]="reachCard.value"
          [class]="'eye'"
          [isLoading]="loadingGlobalStatics$ | async"
          [infoTooltip]="'infoTooltip.reach' | translate"
        >
        </app-card>
      </div>
      <div
        class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 box-col-3 p-r-0"
      >
        <app-card
          [title]="routersCard.title"
          [icon]="routersCard.icon"
          [value]="routersCard.value"
          [class]="'eye'"
          [changes]="routersCard.changes"
          [growth]="routersCard.growth"
          [hasYesterdayGrowth]="routersCard.hasYesterdayGrowth"
          [isLoading]="loadingGlobalStatics$ | async"
        >
        </app-card>
      </div>
    </div>
    <app-help [link]="bookMeeting" [type]="'lp'"></app-help>
  </ng-container>
  <app-audience
    [inputAudience$]="inputAudience"
    [isPremium]="true"
    [startDate]="startDate"
    [endDate]="today"
  ></app-audience>
  <app-latest-ad [companyName]="LPcompanyName"></app-latest-ad>
</div>
